<template>
  <div class="preview-box">
    <div class="preview-box-inner">
      <v-icon
          class="no-print first-preview"
          @click="customerView()"
      >mdi-account</v-icon>
      <v-icon
          class="no-print print-preview"
          @click="print()"
      >mdi-printer</v-icon>
      <v-icon
          class="no-print close-preview"
          @click="goBack()"
      >mdi-close-circle</v-icon>
      <div class="preview-inner">
        <v-row class="mt-0">
          <v-col class="col-8"></v-col>
          <v-col class="col-4">
            <img width="180px" src="../../assets/logo.png" alt="" />
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col class="col-6 address-corner">
            <p>
              {{ survey.customer }}<br />
              <span v-if="survey.customerAddressOne">{{ survey.customerAddressOne }}, <br /></span>
              <span v-if="survey.customerAddressTwo">{{ survey.customerAddressTwo }}, <br /></span>
              <span v-if="survey.customerAddressThree">{{ survey.customerAddressThree }}, <br /></span>
              <span v-if="survey.customerAddressFour">{{ survey.customerAddressFour }}, <br /></span>
              <span v-if="survey.customerAddressFive">{{ survey.customerAddressFive }}, <br /></span>
              <span v-if="survey.customerPostcode">{{ survey.customerPostcode }}</span>
            </p>
            <p>
              Area(s) to be surveyed:<br />
              <span v-if="survey.external">External</span>
              <span v-if="survey.internal">Internal</span>
            </p>
          </v-col>
          <v-col class="col-6">
            Date of survey: {{ survey.prettyDate }}<br />
            Site address: {{ survey.address }}<br />
            AM/PM: <span v-if="survey.am">AM</span><span v-else>PM</span><br />
            Contact: {{ survey.contact }}<br />
            Contact number: {{ survey.contact_number }}<br />
            Booking notes: {{ survey.booking_notes }}<br />
            Vehicle: {{ survey.vehicle }}<br />
            Requested by: {{ survey.requestor }}<br />
            To be surveyed by: {{ survey.surveyor }}
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col class="col-8">
            <h2 class="large-heading pb-4">Works Survey</h2>
            <h4>Date: {{ survey.prettyDate }}</h4>
            <p class="pt-2">Customer reference: {{ survey.customer_reference }}</p>
            <p>
              Work ares:
              <span v-if="survey.internal">Internal</span>
              <span v-if="survey.external">External</span>
            </p>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col class="col-8">
            <h6>Surveyors Notes:</h6>
            <div v-html="survey.surveyors_notes"></div>
          </v-col>
        </v-row>
        <v-row :key="index" v-for="(section, index) in surveySections">
          <v-col class="col-4">
            <p>Item #{{ (index + 1) }}</p>
            <p>{{ section.title}}</p>
            <p>{{ section.description }}</p>
          </v-col>
          <v-col class="col-8">
            <v-row>
              <v-col
                  class="col-3"
                  :key="findex"
                  v-for="(file, findex) in section.files">
                <img :src="file.uri" alt="" />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-12">
            <h6 class="q-mt-xs q-mb-xs">BOQs</h6>
            <v-simple-table>
              <thead>
              <tr>
                <th class="text-left">Description</th>
                <th class="text-left">Material</th>
                <th class="text-left">Colour</th>
                <th class="text-left">Quantity</th>
                <th class="text-left">Unit</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(boq, index) in section.boqs" :key="index">
                <td>{{ boq.boq }}</td>
                <td>{{ boq.material }}</td>
                <td>{{ boq.colour }}</td>
                <td>{{ boq.quantity }}</td>
                <td>{{ boq.unit }}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col class="col-12">
            <hr class="mt-4" />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios';
import Localbase from "localbase";

export default {
  name: 'ViewSurvey',
  computed: {
    token() {
      return this.$store.state.token;
    },
    userid() {
      return this.$store.state.userid;
    },
  },
  data() {
    return {
      survey: {
        address: '',
        customer: '',
        prettyDate: '',
        id: 0,
        requestor: '',
        surveyor: '',
      },
      surveySections: [],
    };
  },
  methods: {
    customerView() {
      this.$router.push(`/surveys/print-view/${this.survey.id}`);
    },
    print() {
      window.print();
    },
    goBack() {
      this.$router.go('-1');
    },
    getSurvey() {
      axios.get(`/siteSurveys/getOne/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.survey = response.data.survey;
          });
    },
    getSurveySections() {
      axios.get(`/siteSurveySections/get/${this.$route.params.id}.json?token=${this.token}`)
          .then((response) => {
            this.surveySections = response.data.sections;
          });
    },
    checkForCredentials() {
      const db = new Localbase('db');
      db.config.debug = false;
      db.collection('users').get().then((users) => {
        if (users[0]) {
          this.$store.commit('useCredentials', users[0]);
          // test if these are still valid
          const testToken = users[0].token;
          axios.post(`/users/testCredentials.json?token=${testToken}`)
              .then((response) => {
                if (response.data !== true) {
                  this.$router.push('/');
                  this.$store.dispatch('unsetCredentials');
                  this.hide = false;
                } else {
                  this.getSurvey();
                  this.getSurveySections();
                }
              })
              .catch((error) => {
                console.log(error);
                this.$store.dispatch('unsetCredentials');
                this.hide = false;
              });
        } else {
          this.$router.push('/');
        }
      });
    },
  },
  mounted() {
    this.checkForCredentials();
  },
};
</script>

<style lang="scss" scoped>
.terms-heading {
  fonts-size: 14px;
}
@page {
  size: A4;
  margin: 0;
}
@media print {
  html, body {
    width: 210mm;
    height: 297mm;
  }
  .preview-inner {
    margin: 10mm 5mm 10mm 5mm;
  }
  .numbered-para {
    font-size: 10px;
    margin-bottom: 11px;
  }
  .text-small {
    font-size: 14px;
  }
  .print-no-top-marg {
    margin-top: 0;
    padding-top: 0;
  }
}
</style>
